import { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

const FileAttach = ({
	label = 'Choose File',
	placeholder = 'No Files Selected',
	onChange,
	accept = '*', // TODO: probably change to specific file for more safety
	multiple = false,
	...props
}) => {
	const [fileName, setFileName] = useState(placeholder)

	const handleChange = (e) => {
		const files = Array.from(e.target.files)
		const names = files.map((file) => file.name).join(', ')
		setFileName(names || placeholder)

		if (onChange) onChange(e)
	}

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				border: '1px solid #DFE4EB',
				borderRadius: '8px',
				padding: '10px 12px',
				backgroundColor: '#fff',
				width: '100%',
				fontFamily: 'Inter, sans-serif',
			}}
		>
			<Button
				component="label"
				variant="outlined"
				sx={{
					backgroundColor: '#F2F6F8',
					color: '#9AA4B3',
					textTransform: 'none',
					fontWeight: 400,
					fontSize: '14px',
					padding: '0 4px',
					position: 'relative',
					overflow: 'hidden',
					outline: 'none',
					border: 'none',
					borderRadius: '6px',
					cursor: 'pointer',

					'&:hover': {
						backgroundColor: '#e6ecf1',
					},
					'& input': {
						margin: '0',
					},
					// Ensure input takes the whole button
					'input[type="file"]': {
						position: 'absolute',
						inset: 0,
						opacity: 0,
						width: '100%',
						height: '100%',
						cursor: 'pointer',
					},
				}}
			>
				{label}
				<input
					type="file"
					accept={accept}
					multiple={multiple}
					onChange={handleChange}
					{...props}
				/>
			</Button>

			<Typography
				variant="body2"
				sx={{
					color: '#8692A4',
					fontSize: '14px',
					fontWeight: 400,
					ml: 2,
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
					flex: 1,
					textAlign: 'right',
				}}
			>
				{fileName}
			</Typography>
		</Box>
	)
}

export default FileAttach
